import { render, staticRenderFns } from "./LocatieInformatieHeader.vue?vue&type=template&id=6ea2e8c0&"
import script from "./LocatieInformatieHeader.vue?vue&type=script&lang=js&"
export * from "./LocatieInformatieHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports